import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../../../shared/shared.module';
import { ScanResultsComponent } from './scan-results.component';
import { ViewScanResultsSummaryComponent } from './view-scan-results-summary/view-scan-results-summary.component';
import { IssuesByWCAGLevelComponent } from './issues-by-standard/issues-by-wcag-level/issues-by-wcag-level.component';
import { IssuesOfNonLeveledStandardComponent } from './issues-by-standard/issues-of-non-leveled-standard/issues-of-non-leveled-standard.component';
import { ViewScanResultsAggregatedIssuesComponent } from './view-scan-results-aggregated-issues/view-scan-results-aggregated-issues.component';
import { ViewScanResultsAccessibilityHealthComponent } from './view-scan-results-accessibility-health/view-scan-results-accessibility-health.component';
import { ExcludedRulesModalComponent } from './view-scan-results-aggregated-issues/excluded-rules-modal/excluded-rules-modal.component';
import { ViewScanResultsIssuesBySeverityComponent } from './view-scan-results-issues-by-severity/view-scan-results-issues-by-severity.component';
import { IssueActionModalComponent } from './reports/issue-action-modal/issue-action-modal.component';
import { ScanResultsRoutingModule } from './scan-results.routing';
import { ViewScanResultsPagesNotScannedComponent } from './view-scan-results-pages-not-scanned/view-scan-results-pages-not-scanned.component';
import { ViewScanResultsPagesComponent } from './view-scan-results-pages/view-scan-results-pages.component';
import { IssuesViewComponent } from './issues-view/issues-view.component';
import { IssuesViewRuleInfoComponent } from './issues-view/issues-view-rule-info/issues-view-rule-info.component';
import { IssuesViewTableActionsComponent } from './issues-view/issues-view-table-actions/issues-view-table-actions.component';
import { IssuesAdvancedSearchComponent } from './issues-view/issues-advanced-search/issues-advanced-search.component';
import { ViewScanResultsScannableDocumentsComponent } from './view-scan-results-scannable-documents/view-scan-results-scannable-documents.component';
import { ViewScannableDocumentUrlsComponent } from './view-scannable-document-urls/view-scannable-document-urls.component';
import { ViewScanResultsComponentsComponent } from './view-scan-results-components/view-scan-results-components.component';
import { ViewScanResultsScanPointsComponent } from './view-scan-results-scan-points/view-scan-results-scan-points.component';
import { ViewScanResultsIssuesByRuleComponent } from './view-scan-results-issues-by-rule/view-scan-results-issues-by-rule.component';
import { ShareReportModalComponent } from './view-scan-results-summary/share-report-modal/share-report-modal.component';
import { IssuesViewBannerComponent } from './issues-view/issues-view-banner/issues-view-banner.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ScanResultsRoutingModule,
    FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
    ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
  ],
  declarations: [
    ScanResultsComponent,
    ViewScanResultsSummaryComponent,
    ViewScanResultsAggregatedIssuesComponent,
    IssuesByWCAGLevelComponent,
    IssuesOfNonLeveledStandardComponent,
    ViewScanResultsAccessibilityHealthComponent,
    ShareReportModalComponent,
    ExcludedRulesModalComponent,
    ViewScanResultsIssuesBySeverityComponent,
    ViewScanResultsIssuesByRuleComponent,
    ViewScanResultsPagesNotScannedComponent,
    ViewScanResultsPagesComponent,
    IssueActionModalComponent,
    IssuesViewComponent,
    IssuesViewRuleInfoComponent,
    IssuesViewTableActionsComponent,
    IssuesViewBannerComponent,
    IssuesAdvancedSearchComponent,
    ViewScanResultsScannableDocumentsComponent,
    ViewScannableDocumentUrlsComponent,
    ViewScanResultsComponentsComponent,
    ViewScanResultsScanPointsComponent,
  ],
  providers: [TitleCasePipe],
  exports: [
    ScanResultsComponent,
    ViewScanResultsComponentsComponent,
    ViewScanResultsIssuesByRuleComponent,
    ViewScanResultsScannableDocumentsComponent,
    IssuesViewRuleInfoComponent,
    IssuesAdvancedSearchComponent,
  ],
})
export class ScanResultsModule {}
